export default __webpack_public_path__ + "static/media/Banner_Guardians_Pics.e54e348a.png";